import React from 'react';
import Footer from '../components/Footer';

import gal1 from '../components/img/gal1.jpg';
import gal2 from '../components/img/gal2.jpg';
import gal3 from '../components/img/gal3.jpg';

const Gallery = () => {
  return (
    <>
      <div style={{ textAlign: 'center', padding: '20px' }}>
        <h1>Gallery</h1>
        <div style={{ display: 'flex', justifyContent: 'center', gap: '20px', flexWrap: 'wrap' }}>
          <img src={gal1} alt="Gallery 1" style={{ width: '300px', borderRadius: '10px' }} />
          <img src={gal2} alt="Gallery 2" style={{ width: '300px', borderRadius: '10px' }} />
          <img src={gal3} alt="Gallery 3" style={{ width: '300px', borderRadius: '10px' }} />
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Gallery;
